// Drag utilities for making toolbar draggable
export interface DragState {
    isDragging: boolean;
    dragOffset: { x: number; y: number };
}

export const createDragHandlers = (toolbar: HTMLDivElement) => {
    let isDragging = false;
    const dragOffset = { x: 0, y: 0 };

    const handleMouseDown = (e: MouseEvent) => {
        // Don't start dragging if clicking on toolbar controls
        const target = e.target as HTMLElement;
        if (
            target.tagName === 'BUTTON' ||
            target.tagName === 'SELECT' ||
            target.closest('button, select')
        ) {
            return;
        }

        isDragging = true;
        const rect = toolbar.getBoundingClientRect();
        dragOffset.x = e.clientX - rect.left;
        dragOffset.y = e.clientY - rect.top;

        e.preventDefault();
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isDragging) return;

        const x = e.clientX - dragOffset.x;
        const y = e.clientY - dragOffset.y;

        // Keep toolbar within viewport bounds
        const maxX = window.innerWidth - toolbar.offsetWidth;
        const maxY = window.innerHeight - toolbar.offsetHeight;

        const clampedX = Math.max(0, Math.min(x, maxX));
        const clampedY = Math.max(0, Math.min(y, maxY));

        toolbar.style.left = `${clampedX}px`;
        toolbar.style.top = `${clampedY}px`;
    };

    const handleMouseUp = () => {
        isDragging = false;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const cleanup = () => {
        toolbar.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    toolbar.addEventListener('mousedown', handleMouseDown);

    return { cleanup };
};
